interface KpiData {
    id: number;
    kpiId: number;
    amount: number | null | '';  // TODO: check why string is needed here
    estimated: number | null;
    note: string | null;
    month: number;
    year: number;
    generatedByFrontend?: boolean;
}

const EmptyKpiData: KpiData = {
    id: 0,
    kpiId: 0,
    amount: null,
    estimated: null,
    note: null,
    month: 1,
    year: 1999
};

export { EmptyKpiData };

export default KpiData;
